import React, { useState, useEffect, useRef } from 'react';
import { Tooltip } from 'antd';

export default function TooltipEllipis(props: any) {
  const { children, isUseInCheckBox } = props;
  const [show, setShow] = useState<boolean>(false);

  const childrenRef = useRef<any>(null);

  useEffect(() => {
    // 在CheckBox中使用的话Antd会为slot内容包裹一层span，需要另外处理
    const target = isUseInCheckBox
      ? childrenRef.current.parentElement
      : childrenRef.current;
    const { scrollWidth, clientWidth } = target;
    setShow(scrollWidth > clientWidth);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [childrenRef]);

  const renderChildren = function () {
    return React.cloneElement(children, {
      ref: childrenRef,
    });
  };

  return show ? (
    <Tooltip {...props}>{renderChildren()}</Tooltip>
  ) : (
    <>{renderChildren()}</>
  );
}
